<template>
  <v-container fluid grid-list-lg>
    <page-loading v-show="loading"></page-loading>
    <transition name="fade-transition">
      <div v-if="noutate !== undefined">
        <h3 class="headline">{{ noutate.titlu }}</h3>
        <div><small>{{ publicatLabel }} {{ noutate.publicat_la }}</small></div>
        <div v-if="noutate.are_document">
          <a @click.prevent.stop="openLink(noutate.url)" :href="noutate.url" target="_system" class="externalLink">
            <v-icon small>link</v-icon>
            <span>{{ titluDocument }}</span>
          </a>
        </div>
        <div v-html="noutate.continut" class="mt-3"></div>
      </div>
    </transition>
  </v-container>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex';
  import { find } from '@/modules/noutati/index.js';
  import keywords from '@/modules/noutati/lang/index.js';

  export default {
    props: {
      id: [Number, String]
    },
    data() {
      return {
        loading: false,
        noutate: undefined
      }
    },
    computed: {
      ...mapGetters(['language']),
      publicatLabel() {
        const { publicat_label } = keywords[this.language];
        return publicat_label;
      },
      titluDocument(){
        const titlu = this.noutate.titlu_document.trim();

        return titlu.length > 0 ? titlu : this.noutate.url;
      }
    },
    methods: {
      ...mapActions({
        markAsRead: 'noutati/markAsRead'
      }),
      openLink (url) {
        cordova.InAppBrowser.open(url, '_system', 'location=yes');
      },
      load() {
        this.loading = true;

        return find(this.language, this.id)
          .then(r => r.json())
          .then(payload => {
            this.noutate = payload.data;
            this.markAsRead(payload.data.id);
          })
          .catch(e => {
            console.log(e);
          })
          .then(() => {
            this.loading = false;
          });
      }
    },
    mounted() {
      this.load();
    }
  }
</script>
<style lang="stylus">
.externalLink
  text-transform uppercase
  font-size 0.9em
  display block
  padding 3px
  &:hover
    background-color #eee
  .v-icon
    margin-right 5px
</style>
